import { PermanentJobsApi } from '../clients';
import { OverlappingJobError } from '../errors';
import { ICreateOnsiteInterviewPayload } from '../types';

export const createOnsiteInterviews = async (
  payload: ICreateOnsiteInterviewPayload,
): Promise<void> => {
  try {
    await PermanentJobsApi.createOnsiteInterviews(payload);
  } catch (error) {
    const errOverlappingJob = OverlappingJobError.fromAxiosError(error);

    if (errOverlappingJob) {
      throw errOverlappingJob;
    }

    throw error;
  }
};
